/**
 * 主页技能信息
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Button, Tabs, message } from 'antd';
import Util from '../../../script/util';
import SkillDetailModal from './SkillDetailModal';
import HTTP from '../../../script/service';
import { connect } from 'react-redux';
import store from '../../../store/store';
import { _dssp_send_click } from '../../../store/Action';
import SkillAudio from './SkillAudio';
import { DDEmpty, DDLoading } from '../../globalPageStatus';
import OtherDsRecommend from './OtherDsRecommend';
import { PopoverEight, PopoverGiveFull, SkillUnitPrice } from './DiscountsTip';
import './DsUserSkillInfo.scss';

const { TabPane } = Tabs;

class DsUserSkillInfo extends PureComponent {
  state = {
    loading: false, // 加载中
    selCat: null, // 选择的技能
    godCategoryList: [], // 技能列表
    hasGivefull: false, // 是否还能买二送一
    skillOrderNum: 1, // 技能下单数量
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.ds?.uid !== this.props.ds?.uid ||
      prevProps.ehot !== this.props.ehot
    ) {
      const ds = this.props.ds;
      this.setState(
        { godCategoryList: ds?.godCategoryList ?? [] },
        this.getDsSkills
      );
    }
  }

  componentDidMount() {
    const { ds } = this.props;
    this.setState(
      { godCategoryList: ds?.godCategoryList ?? [] },
      this.getDsSkills
    );
  }

  // 获取技能列表
  getDsSkills = () => {
    const { ehot, dsid, jnid } = this.props;
    const { godCategoryList } = this.state;
    this.setState({ loading: true }, () => {
      //8元专区
      if (ehot) {
        HTTP._get_eight_god_detail({
          uid: dsid,
          myUid: this.props.base.uid,
        })
          .then((res) => {
            if (res?.code === 200 && !!res?.data) {
              this.setState(
                { godCategoryList: res.data.godCategoryList },
                () => {
                  let categoryId = this.state.godCategoryList[0].categoryId;
                  this.state.godCategoryList.forEach((item, i) => {
                    if (item.categoryId == jnid) categoryId = item.categoryId;
                  });
                  this.setSelCat(categoryId);
                }
              );
            } else {
              message.error(res.message);
            }
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      }
      //普通
      else {
        if (godCategoryList) {
          let categoryId = godCategoryList?.length
            ? godCategoryList[0].categoryId
            : null;
          godCategoryList.forEach((item, i) => {
            if (item.categoryId == jnid) categoryId = item.categoryId;
          });

          this.setSelCat(categoryId);
        } else {
          message.error('未找到该品类');
        }
        this.setState({ loading: false });
      }
    });
  };
  // 选择的技能
  setSelCat = async (categoryId) => {
    const { base, ehot } = this.props;
    const { godCategoryList } = this.state;
    if (godCategoryList?.length > 0) {
      const item = godCategoryList.find(
        (item) => item.categoryId == categoryId
      );
      if (ehot) {
        await HTTP._get_eight_god_category_detailed({
          uid: item.uid,
          categoryId: item.categoryId,
        }).then((res) => {
          if (res?.code === 200) {
            // this.props.updateSelectCategory(`${window.location.origin}/index?dsid=${item.uid}&jnid=${item.categoryId}&ehot=true`, item.categoryName);
            this.setState({ selCat: { ...res.data, icon: item.icon } }, () => {
              // 自动播放音频
              setTimeout(() => {
                this.skillAudioEle && this.skillAudioEle.playAudio();
              }, 500);
            });
          }
        });
      } else {
        await HTTP._get_god_category_detail({
          uid: item.uid,
          categoryId: item.categoryId,
        }).then((res) => {
          if (res?.code === 200) {
            this.setState({ selCat: { ...res.data, icon: item.icon } }, () => {
              // 自动播放音频
              setTimeout(() => {
                this.skillAudioEle && this.skillAudioEle.playAudio();
              }, 500);

              if (
                !!base?.dsModal?.jnid &&
                base?.dsModal?.jnid == item.categoryId &&
                !!base?.dsModal?.isOpenDetail
              ) {
                this.openSkillDetail();
                // 删除 redux 中缓存的 isOpenDetail 状态
                store.dispatch({
                  type: 'change_ds_modal',
                  data: { dsModal: { ...base.dsModal, isOpenDetail: false } },
                });
              }
            });
          }
        });
      }
      this.props.updateSelectCategory(item, ehot);

      this.setState({ curCategoryId: categoryId, skillOrderNum: 1 });
      //上报
      _dssp_send_click(68, {
        dsid: item.uid,
        categoryId: item.categoryId,
        online: item.ifOnline,
      });
    } else {
      this.setState({ selCat: null });
    }

    this.getHasGiveFull();
  };

  stopAudio = () => {
    this.skillAudioEle?.audioEnded?.();
  }
  //创建订单
  addOrder = () => {
    const { ehot, openOrderElement } = this.props;
    const { selCat, hasGivefull, skillOrderNum } = this.state;
    const { uid, categoryId, fullGiveStutas } = selCat;
    openOrderElement({
      uid,
      jnid: categoryId,
      num: fullGiveStutas ? 3 : skillOrderNum,
      isHasGivefull: hasGivefull,
      isEhot: ehot,
      money: selCat.price * (fullGiveStutas ? 3 : skillOrderNum),
    });

    _dssp_send_click(91, {
      to: uid,
      action: 'order',
    });
  };
  //是否还能买二送一
  getHasGiveFull = () => {
    const { base } = this.props;
    if (!base.uid || !base.token) {
      return;
    }
    HTTP._is_order_plus_limit({}).then((res) => {
      if (res?.code === 200) {
        this.setState({
          hasGivefull: res.data,
        });
      }
    });
  };
  // 改变技能下单数量
  changeSkillNum = (type) => {
    const { ehot } = this.props;
    const { skillOrderNum } = this.state;
    if (ehot) {
      message.info('8元订单只允许购买一次');
      return;
    }
    if (type === -1 && skillOrderNum < 2) {
      return;
    }
    this.setState({ skillOrderNum: skillOrderNum + type });
  };

  // 打开技能详情
  openSkillDetail = () => {
    this.skillDetailModalEle.showModal({ num: this.state.skillOrderNum });
  };

  render() {
    const {
      history,
      base,
      ehot,
      ds,
      close,
      isVipServer,
      dsid,
      openNimChat,
      openUserInfo,
      inRoom,
    } = this.props;
    const {
      loading,
      godCategoryList,
      selCat,
      curCategoryId,
      skillOrderNum,
      hasGivefull,
    } = this.state;
    return (
      <DDLoading status={loading}>
        <div className="ds-user-skill-info">
          {!!ds?.ifGod ? (
            ds?.godCategoryList?.length ? (
              <>
                <div className="max-title skill-title">
                  <div className="icon" />
                  <h3 className="title">技能资料</h3>
                </div>
                {godCategoryList?.length ? (
                  <Tabs
                    className="skills-tab"
                    activeKey={`${curCategoryId}`}
                    onChange={this.setSelCat}
                    items={godCategoryList.map((item) => ({
                      key: item.categoryId.toString(),
                      label: (
                        <span className="skill-name">{item.categoryName}</span>
                      ),
                    }))}
                  />
                ) : null}
                <div className="skill-detail-wrap">
                  {selCat?.categoryId && (
                    <div className="skill-content">
                      <div className="skill-cover">
                        <img
                          src={Util.transImgUrl(selCat.icon, '80x80')}
                          alt="技能名称"
                        />
                      </div>
                      <div className="skill-info">
                        <div className="skill-name">
                          <span className="label">{selCat.categoryName}</span>
                          <SkillAudio
                            ref={(el) => (this.skillAudioEle = el)}
                            selCat={selCat}
                          />
                        </div>
                        <p className="skill-num">
                          <span className="label">接单数量：</span>
                          <span className="value">{selCat.orderNum}次</span>
                        </p>
                        {!!selCat?.showCategoryLevel && (
                          <p className="skill-level">
                            <span className="label">技能等级：</span>
                            <span className="value">
                              <span className="level-tag">
                                <span
                                  className="skill-mini-cover"
                                  style={{
                                    backgroundImage: `url(${Util.transImgUrl(selCat.icon, '20x20')})`,
                                  }}
                                />
                                <label>{selCat.level}</label>
                              </span>
                            </span>
                          </p>
                        )}
                      </div>
                      {/* 买2送1 */}
                      {selCat.fullGiveStutas && !hasGivefull ? (
                        <PopoverGiveFull />
                      ) : null}
                      {/* 八元优惠提示 */}
                      {!!ehot && <PopoverEight />}
                      <div className="skill-order-num">
                        <span
                          className="reduce"
                          onClick={() => this.changeSkillNum(-1)}
                        />
                        <span className="number">{skillOrderNum}</span>
                        <span
                          className="plus"
                          onClick={() => this.changeSkillNum(1)}
                        />
                      </div>
                      <SkillUnitPrice
                        lang={base.rootConfig.lang}
                        price={selCat.price}
                      />
                    </div>
                  )}
                  <div className="skill-tip" />
                  {selCat && !isVipServer && (
                    <div className="skill-footer">
                      <Button
                        className="daidai-btn-primary btn-skill-detail"
                        onClick={this.openSkillDetail}
                      >
                        {/*详情*/}
                      </Button>
                      <Button
                        className="daidai-btn-primary btn-skill-pay"
                        onClick={this.addOrder}
                      >
                        立即下单
                      </Button>
                    </div>
                  )}
                </div>

                <SkillDetailModal
                  wrappedComponentRef={(el) => (this.skillDetailModalEle = el)}
                  base={base}
                  ehot={ehot}
                  dsid={dsid}
                  selCat={selCat}
                  hasGivefull={hasGivefull}
                  openNimChat={openNimChat}
                  addOrder={this.addOrder}
                  skillOrderNum={skillOrderNum}
                  changeSkillNum={this.changeSkillNum}
                />
              </>
            ) : (
              <>
                <div className="not-cat">
                  <DDEmpty description="该大神暂时不可接单" />
                </div>
                <OtherDsRecommend
                  history={history}
                  close={close}
                  openUserInfo={openUserInfo}
                  inRoom={inRoom}
                />
              </>
            )
          ) : (
            <OtherDsRecommend
              history={history}
              close={close}
              openUserInfo={openUserInfo}
              inRoom={inRoom}
            />
          )}
        </div>
      </DDLoading>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(DsUserSkillInfo, { withRef: true })
);
